import Link from "next/link";
import { TextFieldElement } from "../widgets/Form/TextFieldElement";
import { Button, FormControlLabel } from "@mui/material";
import IconLogin from "../icons/IconLogin";
import RadioGroupElement from "../widgets/Form/RadioGroupElement";
import BrithDayField from "../widgets/Form/BirthDayField";
import { useFormContext } from "@graphcommerce/ecommerce-ui";
import { useMutation, useQuery } from "@graphcommerce/graphql";
import { useRouter } from "next/router";
import { createAccountOTPDocument } from "../../graphql/login/createAccountOtp.gql";
import { isNewCustomerDocument } from "../../graphql/login/isNewCustomer.gql";
import { useState } from "react";
import { useLoading } from "../../context/loadingContext";
import { CheckboxElement } from "../widgets/Form/CheckboxElement";
import { createCustomerAccountMutationVariables } from "../../graphql/login/createCustomerAccount.gql";
import CloseBtn from "./CloseBtn";

export default function SignupForm({ setActiveForm, setData }: { setActiveForm: (a: string) => void; setData: (data: any) => void }) {
  const [newCustomerError, setNewCustomerError] = useState<any>(null);
  const { refetch } = useQuery(isNewCustomerDocument, { skip: true, });
  const [createAccountOTP] = useMutation(createAccountOTPDocument)
  const methods = useFormContext();
  const { setLoading } = useLoading();

  const submitHandler = (values: any) => {
    const { firstname = 'کاربر', lastname = 'گرامی', email, password, date_of_birth, gender, mobileNumber } = values as createCustomerAccountMutationVariables;

    setLoading(true);
    refetch({
      mobile: mobileNumber
    }).then(({ data: isNewCustomer }) => {
      if (isNewCustomer.isNewCustomer) {
        createAccountOTP({
          variables: {
            mobileNumber
          }
        }).then((res) => {
          if (!res.errors) {
            setData({
              mode: 'createAccount',
              firstname,
              lastname,
              mobileNumber,
              email: (email && email.length > 0) ? email : `${mobileNumber}@gmail.com`,
              password,
              date_of_birth,
              gender: Number(gender)
            })
            setNewCustomerError(null)
            setActiveForm('sendcode');
            setLoading(false)
          }
        })
      } else {
        setLoading(false);
        setNewCustomerError(true);
      }
    })
  }
  return (
    <div className="pt-16 md:pt-5">
      {newCustomerError && <div className="text-sm text-error-500 font-normal text-center my-4">
        این تلفن همراه قبلاً ثبت شده است <Link className="text-primary-500 font-normal" href={'/account/forgot-password'}>(بازیابی رمز عبور)</Link>
      </div>}
      <p className="text-base font-medium">ایجاد حساب کاربری</p>
      <form onSubmit={methods.handleSubmit(submitHandler)}>


        <div className='w-full px-3'>
          <RadioGroupElement row name='gender' defaultValue={"0"} label="جنسیت" items={[{ label: "خانم", value: "0" }, { label: "آقا", value: "1" }]} />
        </div>


        <div className='w-full px-3 mt-5'>
          <BrithDayField name='date_of_birth' control={methods.control} required defaultValue="1360/06/06" />
        </div>


        <TextFieldElement
          name="mobileNumber"
          label="تلفن همراه"
          type="tel"
          required
          fullWidth
          variant='standard'
          classes={{ root: "!mt-5" }}
          className="!text-sm appearance-none"
          color='primary' />


        <TextFieldElement
          name="email"
          label="ایمیل(اختیاری)"
          type="email"
          fullWidth
          variant='standard'
          classes={{ root: "!mt-5" }}
          className="!text-sm"
          color='primary' />

        <TextFieldElement
          name="password"
          type="password"
          label=" رمز عبور دلخواه شما(حداقل 7 کاراکتر)"
          validation={{
            minLength: {
              value: 7,
              message: 'رمز عبور حداقل 7 کاراکتر است.'
            }
          }}
          required
          fullWidth
          classes={{ root: "!mt-5" }}
          className="!text-sm"
          variant='standard'
          color='primary' />

        <div className="mt-6 flex w-full items-center justify-between">
          <CheckboxElement required rules={{
            required: 'واردکردن موارد ستاره‌دار الزامی است.'
          }} name='aggreement' classes={{ root: "!mr-[-1.2rem]" }} />
          <Link href={'#'}><span className="text-primary-500">قوانین و شرایط</span> استفاده از سایت را خوانده‌ام و با آن‌ها موافقم. </Link>
        </div>

        <div className="flex justify-center items-center mt-4">
          <Button variant="contained" type="submit" color="primary" className="flex w-full md:w-auto text-sm justify-center bg-primary-500 hover:bg-primary-700 transition-colors">
            <IconLogin width={18} height={18} className="ml-1" />
            ثبت
          </Button>
        </div>

        <CloseBtn />
      </form>
    </div>
  )
}